import type { ZodType } from 'zod';
import { z } from 'zod';
import type {
  SurveyDialogueDto,
  SurveyDialogueFilter,
} from '#pie/internal/api/pie-bff';
import { SurveyDialogView } from '#pie/internal/api/pie-bff';
import { getValues } from '#pie/utils/ZodUtils';
import { createFiltersAtom } from './createFiltersAtom';
import { createSortingAtom } from './createSortingAtom';
import type { DefaultSorting } from './defaultSorting';

export const defaultCesFilters = {
  surveyDialogView: SurveyDialogView.Unread,
};
export const cesFiltersSchema: ZodType<SurveyDialogueFilter, unknown> = z
  .object({
    surveyDialogView: z.enum(getValues(SurveyDialogView)),
  })
  .catch(defaultCesFilters);

export const cesFiltersAtom = createFiltersAtom<SurveyDialogueFilter>({
  defaultFilters: defaultCesFilters,
  filtersSchema: cesFiltersSchema,
});

export const defaultCesSorting: DefaultSorting<SurveyDialogueDto> = {
  desc: true,
  id: 'createdOn',
};

export const cesSortingAtom = createSortingAtom({
  defaultSorting: defaultCesSorting,
});
